import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { EnumHelper, FilterRange, ProductCode, AccountFilters, AccountQueryParams, CustomerLoanStatus } from 'common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import moment from 'moment';

@Component({
    selector: 'ifp-account-list-filter-dialog',
    templateUrl: './account-list-filter-dialog.component.html',
    standalone: false
})
export class AccountListFilterDialogComponent implements OnInit {
  form: UntypedFormGroup;
  filters: AccountFilters;
  productCodes = ProductCode;
  statusOptions = EnumHelper.getNamesAndValues(CustomerLoanStatus);
  productTypeOptions = EnumHelper.getNamesAndValues(ProductCode);

  createdOnRange: FilterRange<moment.Moment> = {};

  constructor(public dialogRef: MatDialogRef<AccountListFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder
  ) {
    this.filters = new AccountFilters(data.query);
    this.form = this.formBuilder.group({
      description: this.data.query.description ? this.data.query.description : '',
      externalId: this.data.query.externalId ? this.data.query.externalId : '',
      loanNumber: this.data.query.loanNumber ? this.data.query.loanNumber : '',
      customerStatus: this.data.query.customerStatus ? this.data.query.customerStatus : undefined,
      createdOn: this.data.query.createdOn || '',
      createdOnFrom: new UntypedFormControl(this.data.query.createdOnFrom ? new Date(this.data.query.createdOnFrom) : undefined, { validators: null, updateOn: 'blur' }),
      createdOnTo: new UntypedFormControl(this.data.query.createdOnTo ? new Date(this.data.query.createdOnTo) : undefined, { validators: null, updateOn: 'blur' }),
      favorite: this.data.query.favorite,
      productCode: this.data.query.productCode,
      entityId: this.data.query.entityId,
      excludedProductCode: this.data.query.excludedProductCode
    });

  }

  static show(dialog: MatDialog,
    query: AccountQueryParams,
    productCode: ProductCode
  ): Observable<any> {
    return dialog.open(AccountListFilterDialogComponent, {
      data: { query, productCode },
      closeOnNavigation: true
    }).afterClosed();
  }

  ngOnInit(): void {
    this.createdOnRange.from = this.filters.createdOnFrom;
    this.createdOnRange.to = this.filters.createdOnTo;
  }

  createdDateSelected(dataRange: FilterRange<moment.Moment>) {
    this.form.patchValue({
      createdOnFrom: dataRange.from,
      createdOnTo: dataRange.to
    });
  }

  onConfirmed(formValues: unknown): void {
    this.dialogRef.close(new AccountFilters(formValues));
  }
}
